import React, { PureComponent } from 'react';
import { FormGroup, FormControl, Checkbox } from 'react-bootstrap';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class LoginForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      disabled: true,
      rememberme: false
    };
  }

  onChangeHandler = (e) => {
    if (e.target.checked) {
      this.setState({ rememberme: true });
    } else {
      this.setState({
        rememberme: false
      });
    }
  };

  render() {
    const { podcast, onCancel, onSubmit } = this.props;
    const { username, password } = this.state;

    const isDisabled = username.trim() === '' || password.trim() === '';

    return (
      <form
        onSubmit={(e) => onSubmit(e, username, password, this.state.rememberme)}
        className="podcast-login-form"
      >
        <span className="mb-3">
          Log in to <strong>{podcast}</strong>
        </span>
        <FormGroup controlId="username">
          <FormControl
            componentClass="input"
            className="styleFieldLogin"
            placeholder="Username"
            type="text"
            onChange={(event) =>
              this.setState(byPropKey('username', event.target.value))
            }
          />
        </FormGroup>
        <FormGroup controlId="password">
          <FormControl
            componentClass="input"
            className="styleFieldLogin"
            placeholder="Password"
            type="password"
            onChange={(event) =>
              this.setState(byPropKey('password', event.target.value))
            }
          />
        </FormGroup>
        <Checkbox onChange={this.onChangeHandler}>Remember me</Checkbox>
        <div className="validate-buttons">
          <button className="btn btn-tags" type="submit" disabled={isDisabled}>
            Log In
          </button>
          <button className="btn btn-tags close-validate" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>
    );
  }
}

export default LoginForm;
